import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const Highlight = styled.div`
  width: 25px;
  height: 20px;
  background: ${props => props.bg};
  margin: 0 4px;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => (props.selected ? '#0080ff' : 'transparent')};
`;

const Box = styled.button`
  width: 100%;
  height: 100%;
  border: 0;
  padding: 0;
  margin: 0;
  background: ${props => props.bg};
`;

const Swatch = ({
  theme, title, bg, selected, selectTheme, value,
}) => (
  <ThemeProvider theme={theme}>
    <Highlight selected={selected}>
      <Box bg={bg} title={title} onClick={selectTheme} value={value} />
    </Highlight>
  </ThemeProvider>
);

export default withTheme(Swatch);



// WEBPACK FOOTER //
// ./src/components/Swatch.js